import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Layout from "./Layout";
import SlotMachineDonation from "./merged";
import PrivacyPolicy from "./PrivacyPolicy";
import TermsOfService from "./TermsOfService";
import Contact from "./Contact";
import MaxWins from "./MaxWins";
import LivesChanged from "./LivesChanged";

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<SlotMachineDonation />} />
            <Route path="privacy" element={<PrivacyPolicy />} />
            <Route path="terms" element={<TermsOfService />} />
            <Route path="contact" element={<Contact />} />
            <Route path="max-wins" element={<MaxWins />} />
            <Route path="lives-changed" element={<LivesChanged />} />
          </Route>
        </Routes>
      </div>
    </Router>
  );
}

export default App;
